import { serverDisconnect } from "../../models/model";
import { actionTypes } from "../action/action";

const initialState = {
  serverDisconnect: false
};

export const serverDisconnectReducer = (state: serverDisconnect = initialState, action: any) => {
  switch (action.type) {
   
      case actionTypes.SERVER_DISCONNECT:
        return{
          ...state, serverDisconnect:action.payload.serverDisconnect
        };

    default:
      return state;
    }
}